import { SQUIDEX_APP, handleGetData } from '.';
import padrao from './layout-padrao.json';

// Cabeçalho, menu e rodapé aparecem na hora, junto com a tela de carregamento:
// são só textos e links, e esperar o Squidex para eles deixava o topo e o pé
// do site em branco. Cada parte nasce com a última versão vista neste
// navegador (localStorage) ou, na primeira visita, com a cópia de produção
// embutida no site (layout-padrao.json, 30/10/2026); depois vem a versão atual
// do Squidex, que substitui a de antes e fica guardada para a próxima visita.
//
// Para atualizar a cópia embutida (ex.: depois de mudar o menu no Squidex):
// ver docs/remodelagem-squidex.md, "Carregamento — tela nova e layout embutido".

const PARTES = {
  header: { caminho: 'api/content/copasul/layoutheader/', extrair: (d) => d?.header?.iv },
  menu: { caminho: 'api/content/copasul/layoutmenu/', extrair: (d) => d?.listaMenus?.iv },
  footer: { caminho: 'api/content/copasul/layoutfooter/', extrair: (d) => d?.footer?.iv },
};

// Uma chave por app: o dev e a produção não misturam o que guardaram.
const chave = (parte) => `copasul:${SQUIDEX_APP}:layout:${parte}`;

export const layoutGuardado = (parte) => {
  try {
    const salvo = window.localStorage.getItem(chave(parte));
    if (salvo) return JSON.parse(salvo);
  } catch {
    // navegador sem localStorage (modo privado, bloqueado): fica a cópia embutida
  }
  return padrao[parte];
};

export const atualizarLayout = async (token, parte) => {
  const { caminho, extrair } = PARTES[parte];
  const r = await handleGetData(token, caminho);
  const valor = extrair(r?.data?.items?.[0]?.data);
  if (!valor) throw new Error(`layout ${parte} vazio`);
  try {
    window.localStorage.setItem(chave(parte), JSON.stringify(valor));
  } catch {
    // sem espaço ou bloqueado: só não guarda
  }
  return valor;
};
